import React, { useContext, useEffect } from "react";

import Link from "next/link";
import useRouter from "@stadium/hooks/lib/use-custom-route";

import { getDefaultBuildYourOwnShopNumber } from "@stadium/redux-utils/selectors/configSelector";
import { useConfig } from "@stadium/hooks/lib/use-config";
import { usePageNameContext } from "@stadium/shared/page-name-provider";

import Input from "@stadium/ui/src/components/input/input";
import Button from "@sharedComponents/buttons";
import { BuildYourOwnTemplateCta } from "@components/all-templates/header";
import TemplateCategoriesModal from "@components/modals/template-categories";

import { CurrentDeviceContext } from "@stadium/ui/src/contexts/responsive-content";
import { useModal } from "@stadium/hooks/lib/use-modal";
import { useInstantSearch } from "@stadium/shared/src/components/instant-search";

import { REQUEST_A_TEMPLATE_URL } from "@constants/banner";
import { TEMPLATES, MOMENTS, MOMENTS_ROUTE } from "@constants/routes";
import { TEMPLATE_CATEGORIES } from "@constants/modal-types";
import { ALL_TEMPLATES } from "@constants/templates-listing";

import styles from "./purge-main.module.scss";

const defaultObj = {};

export const RequestTemplateCta = ({ isMomentPage } = defaultObj) => {
  if (isMomentPage) return;
  return (
    <Link
      href={REQUEST_A_TEMPLATE_URL}
      passHref
      className={styles.requestTempalateLink}
      target="_blank"
      rel="noopener"
    >
      REQUEST A TEMPLATE
    </Link>
  );
};

const CategoriesSection = ({
  marketingCategories,
  setCurrentCategory,
  currentCategory,
  onTemplateSelect,
}) => {
  const { setMarketingCategoryId } = useInstantSearch();
  const { name, id } = currentCategory || defaultObj;
  const { replace } = useRouter();
  const buildYourOwnShopNumber = useConfig(getDefaultBuildYourOwnShopNumber);
  const { isMobileDevice } = useContext(CurrentDeviceContext);
  const { openModal, renderModal, isOpen, closeModal } = useModal(
    TEMPLATE_CATEGORIES,
    TemplateCategoriesModal,
  );
  const pageName = usePageNameContext();
  const isMomentPage = pageName === MOMENTS;
  const DEFAULT_CATEGORY_TEXT = `All ${isMomentPage ? "Moments" : "Templates"}`;

  const handleCategoryClick = ({ name, slug, id }) => {
    setMarketingCategoryId(id);
    if (isMobileDevice) closeModal();
    setCurrentCategory({ ...currentCategory, name });
    const baseRoute = isMomentPage ? MOMENTS_ROUTE : TEMPLATES;
    replace(`${baseRoute}/${slug}`);
  };

  useEffect(() => {
    if (name && !id && name !== ALL_TEMPLATES.toLowerCase() && marketingCategories?.length) {
      const currentCategoryId = marketingCategories.find(
        ({ name: categoryName }) => name === categoryName,
      )?.id;
      if (currentCategoryId) {
        setMarketingCategoryId(currentCategoryId);
      }
    }
  }, [name, id, marketingCategories?.length]);

  const renderCategoriesView = () =>
    marketingCategories.map(({ name: categoryName, slug, id: categoryId }) => {
      return (
        <Button
          key={slug}
          styleType="no-style"
          onClick={() => handleCategoryClick({ name: categoryName, slug, id: categoryId })}
          className={`${styles.categoriesSideBarLinkHolder} ${categoryName === name ? styles.activeCategory : ""
            }`}
          displayChildren={false}
          title={categoryName}
        >
          <span className={styles.categoriesSideBarLink}>{categoryName}</span>
        </Button>
      );
    });

  const displayCurrentDropdownCategory = name ? `${name}` : DEFAULT_CATEGORY_TEXT;

  return (
    <div className={styles.categoriesSideBarSection}>
      <div className={styles.categoriesSideBarTitle} tabIndex={0}>BROWSE BY CATEGORY</div>
      <div className={styles.categoriesSideBarListHolder}>
        {isMobileDevice ? (
          <div className={styles.cartegoryDropdownHolder} onClick={openModal}>
            <Input
              customClass={styles.searchInput}
              value={displayCurrentDropdownCategory}
              readOnly
            />
            <span className={`${styles.arrowIcon} ${isOpen ? styles.iconUp : ""}`} />
          </div>
        ) : (
          renderCategoriesView()
        )}
        {renderModal({
          data: {
            renderCategoriesView,
          },
        },
          false,
        )}
      </div>
      <div className={styles.categoriesSideBarCtaBlock}>
        <div className={styles.categoriesSideBarBuildOwnButton}>
          <BuildYourOwnTemplateCta
            onTemplateSelect={onTemplateSelect}
            buildYourOwnShopNumber={buildYourOwnShopNumber}
          />
        </div>
        <RequestTemplateCta isMomentPage={isMomentPage} />
      </div>
    </div>
  );
};

export default CategoriesSection;
